/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-danger */
/* eslint-disable react/button-has-type */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DialogModal from '../../../components/modal/DialogModal';
import SnackBar from '../../../components/snackbar/snackbar';
import DeleteAlert from '../../../components/modal/DeleteModal';
import adminServices from '../../../services/adminServices';
import './index.css'

const QuestionViewModal = ({ open, onClose, questions, questionTypeCode, fromChapterPage, hideEditButton = false, sourceName, chapterName, sourceId, chapterId }) => {
  const navigate = useNavigate();
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedQuestionId, setSelectedQuestionId] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarTitle, setSnackbarTitle] = useState('');

  const DeleteQuestion = (id) => {
    setSelectedQuestionId(id)
    setDeleteModalOpen(true)
  }



  const handleDeleteConfirm = async () => {
    try {
      const result = await adminServices.deletQuestionByid(selectedQuestionId);
      if (result.ok) {
        setSnackbarTitle(result?.data?.message || result?.message || "Question deleted successfully");
        setOpenSnackbar(true);
        setTimeout(() => {
          if (result?.data?.message === 'Only created user can delete the assessment' || result?.data?.message === 'This question is already part of sources and cannot be deleted') {
            setDeleteModalOpen(false);
          }
          else {
            setDeleteModalOpen(false);
            onClose();
          }

        }, 2000);
      }
    } catch (error) {
      console.error('Error deleting question:', error);
      setSnackbarTitle('Error deleting question');
      setOpenSnackbar(true);
    }
  };

  // Show loading state while question data is being fetched
  if (!questions && open) {
    return (
      <DialogModal
        open={open}
        handleClose={onClose}
        title="Question Details"
        maxWidth="lg"
      >
        <div className="flex justify-center items-center py-12">
          <div className="text-center">
            <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mb-4" />
            <p className="text-gray-600">Loading question details...</p>
          </div>
        </div>
      </DialogModal>
    );
  }

  if (!open || !questions) return null;

  // Convert to array if single question
  const questionArray = Array.isArray(questions) ? questions : [questions];
  const isPassageMulti = questionArray.length > 1 || questionArray[0]?.question_type === 'PASSAGE_MULTI';
  const currentQuestion = questionArray[currentQuestionIndex];


  // Get passage (same for all questions in PASSAGE_MULTI)
  const passage = questionArray[0]?.passage || questionArray[0]?.passage_text;
  const hasPassage = passage && passage.trim() !== '';

  // Check if current question is NUMERIC
  const isNumeric = currentQuestion.question_type?.toUpperCase() === 'NUMERIC' || currentQuestion.question_type?.toUpperCase() === 'JEENUMERIC';

  // Handle edit click
  const handleEditClick = () => {

    const isMulti = isPassageMulti && questionArray.length >= 1;
    const baseQuestion = isMulti ? questionArray[0] : questionArray[0];

    const enrichedQuestion = {
      ...baseQuestion,
      assessment_source_id: baseQuestion.assessment_source_id || (sourceId ? [Number(sourceId)] : null),
      chapter_id: baseQuestion.chapter_id || (chapterId ? [Number(chapterId)] : null),
      source_names: baseQuestion.source_names || (sourceName ? [sourceName] : []),
      chapter_names: baseQuestion.chapter_names || (chapterName ? [chapterName] : []),
    };

    navigate(`/app/question-edit/${questionArray[0].id}`, {
      state: {
        questionData: isMulti ? questionArray.map((q, i) => i === 0 ? enrichedQuestion : q) : enrichedQuestion,
        fromChapterPage: fromChapterPage || false,
        isPassageMulti: isMulti,
        fromChapterId: chapterId || null,
      }
    });
  };


  // Parse options from a question
  // const parseOptions = (question) => {
  //   if (!question.options?.mcqOptions) return [];

  //   return question.options.mcqOptions.map((option, index) => ({
  //     label: String.fromCharCode(65 + index),
  //     value: option,
  //     isCorrect: question.options.correctAnswer?.[index] || false
  //   }));
  // };

  const parseOptions = (question) => {
    if (!question?.options) return [];

    let optionsData = question.options;

    if (typeof optionsData === "string") {
      try {
        optionsData = JSON.parse(optionsData);
      } catch (err) {
        console.error("Invalid options JSON", err);
        return [];
      }
    }

    if (!optionsData?.mcqOptions) return [];

    return optionsData.mcqOptions.map((option, index) => ({
      label: String.fromCharCode(65 + index),
      value: option,
      isCorrect: optionsData.correctAnswer?.[index] || false
    }));
  };

  // Get correct answers for a question
  const getCorrectAnswers = (question) => {
    const options = parseOptions(question);
    return options
      .filter(opt => opt.isCorrect)
      .map(opt => opt.label)
      .join(', ') || 'N/A';
  };

  // Get difficulty color
  const getDifficultyColor = (level) => {
    switch (level?.toLowerCase()) {
      case 'easy':
        return 'bg-green-600 text-white';
      case 'medium':
        return 'bg-yellow-500 text-white';
      case 'hard':
        return 'bg-red-600 text-white';
      case 'foundation':
        return 'bg-blue-600 text-white';
      default:
        return 'bg-gray-600 text-white';
    }
  };

  // Get question type color
  const getQuestionTypeColor = (type) => {
    switch (type?.toUpperCase()) {
      case 'MCQ':
        return 'bg-blue-600 text-white';
      case 'MCQ_MULTI':
        return 'bg-purple-600 text-white';
      case 'NUMERIC':
        return 'bg-indigo-600 text-white';
      case 'PASSAGE_SINGLE':
        return 'bg-orange-600 text-white';
      case 'PASSAGE_MULTI':
        return 'bg-pink-600 text-white';
      default:
        return 'bg-gray-600 text-white';
    }
  };

  const options = parseOptions(currentQuestion);
  const correctAnswersText = getCorrectAnswers(currentQuestion);
  const sourceCount = currentQuestion?.source_names?.length || questionArray[0]?.source_names?.length || 0;
  const chapterCount = currentQuestion?.chapter_names?.length || questionArray[0]?.chapter_names?.length || 0;
  const displaySourceName = sourceCount ? `${sourceCount} Source${sourceCount > 1 ? 's' : ''}` : '';
  const displayChapterName = chapterCount ? `${chapterCount} Chapter${chapterCount > 1 ? 's' : ''}` : '';


  // Navigate between questions
  const handlePrevQuestion = () => {
    if (currentQuestionIndex > 0) {
      setCurrentQuestionIndex(currentQuestionIndex - 1);
    }
  };

  const handleNextQuestion = () => {
    if (currentQuestionIndex < questionArray.length - 1) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
    }
  };

  return (
    <DialogModal
      open={open}
      handleClose={onClose}
      title="Question Details"
      maxWidth="lg"
      showCloseIcon
    >
      {/* Header with badges and question counter */}
      <div className="mb-4 pb-3 border-b border-gray-200" id="modal-header">
        <div className="flex items-center justify-between flex-wrap gap-2">
          <div className="flex items-center gap-2 flex-wrap">
            {/* Question Type Badge */}
            {(currentQuestion.question_type_description || currentQuestion.question_type_name) && (
              <span id="question-type-badge" className={`px-2 sm:px-3 py-1 text-xs font-semibold rounded uppercase ${getQuestionTypeColor(currentQuestion.question_type_description || currentQuestion.question_type_name)}`}>
                {currentQuestion.question_type_description || currentQuestion.question_type_name}
              </span>
            )}

            {/* Difficulty Badge */}
            {(currentQuestion.level || currentQuestion.difficulty) && (
              <span id="difficulty-badge" className={`px-2 sm:px-3 py-1 text-xs font-semibold rounded uppercase ${getDifficultyColor(currentQuestion.level || currentQuestion.difficulty)}`}>
                {currentQuestion.level || currentQuestion.difficulty}
              </span>
            )}

            {currentQuestion?.assessment_source_id?.length > 0 && (
              <span className="px-3 py-1 text-xs font-semibold rounded-lg border border-gray-200 bg-white text-gray-700">
                Source {currentQuestion?.assessment_source_id?.length}
              </span>
            )}

            {currentQuestion?.chapter_id?.length > 0 && (
              <span className="px-3 py-1 text-xs font-semibold rounded-lg border border-gray-200 bg-white text-gray-700">
                Chapter {currentQuestion?.chapter_id?.length}
              </span>
            )}

            {/* Category */}
            {/* {currentQuestion.category_name && (
              <span className="text-xs sm:text-sm text-gray-900 font-medium break-words">
                {currentQuestion.category_name}
              </span>
            )} */}

            {/* Tag */}
            {/* {currentQuestion.tag_name && (
              <span className="text-xs sm:text-sm text-gray-600 break-words">
                {currentQuestion.tag_name}
              </span>
            )} */}
          </div>

          {/* Question Counter with navigation */}
          {isPassageMulti && questionArray.length > 1 && (
            <div className="flex items-center gap-2">
              <button
                onClick={handlePrevQuestion}
                disabled={currentQuestionIndex === 0}
                id="prev-question-btn"
                className="p-1 hover:bg-gray-100 rounded disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
              </button>
              <span className="text-sm font-medium text-gray-700 whitespace-nowrap" id="question-counter">
                Question {currentQuestionIndex + 1} of {questionArray.length}
              </span>
              <button
                onClick={handleNextQuestion}
                disabled={currentQuestionIndex === questionArray.length - 1}
                id="next-question-btn"
                className="p-1 hover:bg-gray-100 rounded disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Content */}
      <div className="max-h-[calc(100vh-320px)] overflow-y-auto px-1" id="modal-content-area">
        <div className={`grid ${hasPassage ? 'grid-cols-1 lg:grid-cols-2' : 'grid-cols-1'} gap-4 lg:gap-6`}>

          {/* Left side - Passage (if exists) */}
          {hasPassage && (
            <div className="w-full" id="passage-section">
              <div className="bg-white border border-gray-300 rounded-lg p-3 sm:p-4">
                <h3 className="text-sm font-semibold text-gray-700 mb-3">Passage</h3>
                <div
                  className="text-sm text-gray-800 leading-relaxed break-words overflow-wrap-anywhere"
                  style={{ wordBreak: 'break-word', overflowWrap: 'anywhere' }}
                  dangerouslySetInnerHTML={{ __html: passage }}
                />
              </div>
            </div>
          )}

          {/* Right side - Question and Options */}
          <div className="w-full min-w-0" id="question-section">

            {/* Question Text */}
            <div className="mb-4" id="question-text-display">
              <div
                className="text-base text-gray-900 mb-3 break-words overflow-wrap-anywhere"
                style={{ wordBreak: 'break-word', overflowWrap: 'anywhere' }}
                dangerouslySetInnerHTML={{ __html: currentQuestion.question_text || currentQuestion.title }}
              />
            </div>

            {/* Options - For MCQ questions only */}
            {!isNumeric && options.length > 0 && (
              <div className="flex flex-col gap-2 mb-4" id="options-list">
                {options.map((option, index) => (
                  <div
                    key={index}
                    className="flex items-start gap-3 p-2"
                    id={`option-item-${index}`}
                  >
                    {/* Checkbox */}
                    <div className="flex-shrink-0 mt-0.5">
                      <input
                        type="checkbox"
                        checked={option.isCorrect}
                        readOnly
                        className="w-4 h-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 cursor-default"
                      />
                    </div>

                    {/* Option content */}
                    <div className="flex-1 min-w-0">
                      <div
                        className="text-sm text-gray-900 break-words overflow-wrap-anywhere"
                        style={{ wordBreak: 'break-word', overflowWrap: 'anywhere' }}
                        dangerouslySetInnerHTML={{ __html: option.value }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            )}

            {isNumeric && (
              <>
                <div className="mb-4 p-3 sm:p-4 bg-teal-50 border border-teal-200 rounded-lg" id="numeric-answer-details">
                  <div className="flex items-start gap-2">
                    <div className="flex-1">
                      <div className="font-semibold text-teal-900 text-sm mb-2">Answer Details:</div>

                      <div className="text-sm text-teal-800 mb-1">
                        <span className="font-medium">Answer Type:</span>{' '}
                        <span className="capitalize">
                          {currentQuestion.options?.answerType || 'exact'}
                        </span>
                      </div>

                      {currentQuestion.options?.answerType === 'range' ? (
                        <div className="flex gap-6 mt-1">
                          <div className="text-sm text-teal-800">
                            <span className="font-medium">Min Value:</span>{' '}
                            {currentQuestion.options?.minValue ?? currentQuestion.options?.min_value ?? 'N/A'}
                          </div>
                          <div className="text-sm text-teal-800">
                            <span className="font-medium">Max Value:</span>{' '}
                            {currentQuestion.options?.maxValue ?? currentQuestion.options?.max_value ?? 'N/A'}
                          </div>
                        </div>
                      ) : (
                        <div className="text-sm text-teal-800 mb-1">
                          <span className="font-medium">Correct Answer:</span>{' '}
                          {currentQuestion.reference_answer ?? currentQuestion.options?.acceptableAnswers ?? currentQuestion.options?.correctAnswer ?? 'N/A'}
                        </div>
                      )}

                    </div>
                  </div>
                </div>

                <div className="mb-4 p-3 sm:p-4 bg-teal-50 border border-teal-200 rounded-lg">
                  <div className="flex items-start gap-2">
                    <div className="flex-1">
                      <div className="font-semibold text-teal-900 text-sm mb-2">Explanation:</div>
                      {currentQuestion.justification && (
                        <div className="mt-2 pt-2 border-t border-teal-200">
                          <div
                            className="text-sm text-teal-800 break-words overflow-wrap-anywhere"
                            style={{ wordBreak: 'break-word', overflowWrap: 'anywhere' }}
                            dangerouslySetInnerHTML={{ __html: currentQuestion.justification }}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </>
            )}

            {!isNumeric && (options?.length > 0 || currentQuestion.justification) && (
              <>
                {/* <div className="p-4 bg-teal-50 border border-teal-200 rounded-lg">
                  <div className="flex items-start gap-2 mb-3">

                    <div className="flex-1">
                      {options?.length > 0 && (
                        <div className="flex items-center gap-2 mb-2">
                          <span className="font-bold text-teal-900 text-sm">
                            Correct Answer:
                          </span>

                          <span className="text-sm text-teal-800">
                            {correctAnswersText}
                          </span>
                        </div>
                      )}
                    </div>


                  </div>
                </div> */}
                <div className="w-full bg-green-50 border-l-4 border-green-500 rounded-lg px-4 py-3" id="correct-answer-display">
                  <div className="flex items-center gap-3">
                    <span className="text-green-900 font-semibold text-sm">
                      Correct Answer:
                    </span>

                    <span className="bg-green-600 text-white text-sm font-bold px-3 py-1 rounded-md">
                      {correctAnswersText}
                    </span>
                  </div>
                </div>

                <div className="p-4 bg-teal-50 border border-teal-200 rounded-lg mt-2" style={{ backgroundColor: "#F8FAFC" }} id="explanation-section">
                  <div className="flex items-start gap-2 mb-3">

                    <div className="flex-1">
                      <div className="font-bold text-teal-900 text-sm mb-2">
                        Explanation:
                      </div>
                      {currentQuestion.justification && (
                        <div>
                          <div
                            className="rich-text-preview text-sm text-teal-800 break-words overflow-wrap-anywhere" 
                            style={{ wordBreak: 'break-word', overflowWrap: 'anywhere' }}
                            dangerouslySetInnerHTML={{ __html: currentQuestion.justification }}
                          />
                        </div>
                      )}

                    </div>

                  </div>
                </div>
              </>
            )}

          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="flex flex-col sm:flex-row justify-between gap-3 mt-4 pt-3 border-t border-gray-200" id="modal-footer">
        {/* Delete button on the left */}
        {!hideEditButton && (
          <button onClick={() => DeleteQuestion(currentQuestion.id)}
            // onClick={() => {
            //   console.log('Delete question:', currentQuestion.id);
            // }}
            id="delete-question-btn"
            className="w-full sm:w-auto px-4 sm:px-6 py-2 bg-red-600 hover:bg-red-700 text-white font-medium rounded-lg transition-colors flex items-center justify-center gap-2"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
            Delete Question
          </button>
        )}

        {/* Right side buttons */}
        <div className="flex flex-col sm:flex-row gap-3">
          {!hideEditButton && (
            <button
              onClick={handleEditClick}
              id="edit-question-btn"
              className="w-full sm:w-auto px-4 sm:px-6 py-2 bg-purple-600 hover:bg-purple-700 text-white font-medium rounded-lg transition-colors flex items-center justify-center gap-2"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
              </svg>
              Edit Question
            </button>
          )}
          <button
            onClick={onClose}
            id="close-modal-btn"
            className="w-full sm:w-auto px-4 sm:px-6 py-2 bg-white border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors"
          >
            Close
          </button>
        </div>
      </div>

      <SnackBar
        open={openSnackbar}
        snackbarTitle={snackbarTitle}
        close={() => setOpenSnackbar(false)}
      />

      {/* Delete Modal */}
      {deleteModalOpen && (
        <DeleteAlert
          open={deleteModalOpen}
          close={() => setDeleteModalOpen(false)}
          confirm={handleDeleteConfirm}
          title="Delete Question"
          subTitle="Are you sure you want to delete this question? This action cannot be undone."
        />
      )}
    </DialogModal>
  );
};

export default QuestionViewModal;